import './html_package.less';

import $ from 'jquery';
import React, { Component } from 'react';
import autobind from 'class-autobind';

import isArray from 'lodash/isArray';

import EmbeddedIframeSection from '../shared/embedded_iframe_section.jsx';

class HtmlPackageSection extends Component {

  constructor() {
    super();
    autobind(this);
  }

  componentDidMount() {
    window.addEventListener('message', this.handleIframeHeightMessage, false);
  }

  componentWillUnmount() {
    window.removeEventListener('message', this.handleIframeHeightMessage, false);
  }

  handleIframeHeightMessage(evt) {
    // Since the height of iframe sections can be challenging to deal with and
    // scrollbars can ruin the experience, we support a postMessage from the
    // child iframe which returns the scrollHeight of the embed. If the embed
    // has the JavaScript to send the message then we will set the iframe
    // height accordingly. This is an opt-in behavior.
    if (this.iframeRef && evt && evt.data && isArray(evt.data)) {
      const $iframe = $(this.iframeRef);
      const [eventName, data] = evt.data;

      // 'setHtmlPackageSectionHeight' is an event that can be emitted from
      // HTML Package files for which you can find code here:
      // http://support.zoomforth.com/media-library/custom-html-package-guidelines
      if (eventName === 'setHtmlPackageSectionHeight') {
        const { height, url } = data;
        if (url === this.props.htmlPackageEntrypointUrl) {
          $iframe.height(height);

          // if this section is resizing, we don't want it's parent to contain
          // the child as expected.
          $iframe.parent().height('auto');
        }
      }
    }
  }

  render() {
    const { height, uuid, htmlPackageEntrypointUrl, bringToFore, ...rest } = this.props;

    return (
      <EmbeddedIframeSection
        tellRef={(ref)=> {
          this.iframeRef = ref;
        }}
        uuid={uuid}
        height={height}
        bringToFore={bringToFore}
        iframeSrc={htmlPackageEntrypointUrl}
        {...rest}
      />
    );
  }

}

export default HtmlPackageSection;
